import { render, staticRenderFns } from "./remnantDust.vue?vue&type=template&id=06eec761&scoped=true"
import script from "./remnantDust.vue?vue&type=script&lang=js"
export * from "./remnantDust.vue?vue&type=script&lang=js"
import style0 from "./remnantDust.vue?vue&type=style&index=0&id=06eec761&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eec761",
  null
  
)

export default component.exports